import { render, staticRenderFns } from "./WordCloudPrompt.vue?vue&type=template&id=366cadfc"
import script from "./WordCloudPrompt.vue?vue&type=script&lang=js"
export * from "./WordCloudPrompt.vue?vue&type=script&lang=js"
import style0 from "./WordCloudPrompt.vue?vue&type=style&index=0&id=366cadfc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports